<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Chapter-rw" epub:type="bodymatter chapter" id="Chapter1">
<div class="title-block-rw" id="title-block4">
<p class="title-num-rw" id="title-num2"><a href="#/Text/TOC">Chapter 1: What We Lost</a></p>
</div>
<div class="epigraph-rw" id="epigraph3">
<p class="ep1-rw" id="p40">It is the finding of this court that Stacy Mason is innocent. She did not murder her son. She acted in self-defense, and for the good of the community, and we are sorry for her loss.</p>
<p class="source-rw" id="source2">—Judge Vernon, California Supreme Court, January 9, 2018</p>
<p class="ep-rw" id="p41">Oggie?</p>
<p class="source-rw" id="source3">—Phillip Mason</p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s006-Chapter-001.vue?4a45af47